import {DefaultVehicle, type Vehicle} from "@/models/vehicle/vehicle";
import type {StatusHistory} from "@/models/assignment/assignment-list";
import {type Address, DefaultAddress} from "@/models/relation/address";
import {AssignmentStatus} from "@/constants/assignment-status";
import { AssignmentDrivability } from "@/constants/assignment-drivability";
import { AssignmentPriority } from "@/constants/assignment-priority";
import { AssignmentSource } from "@/constants/assignment-source";
import type { TrajectoryEmptyRideStatus } from "@/constants/trajectory-empty-ride-status";
import type {WindowInputMode} from "@/constants/window-input-mode";

export interface Assignment {
    id: number;
    reference?: string;
    clientName?: string;
    clientId?: number;
    ownerName?: string;
    ownerId?: number;
    pickUpRelationName: string;
    pickUpRelationId: number;
    pickUpAddress: Address;
    dropOffRelationName: string;
    dropOffRelationId: number;
    dropOffAddress: Address;
    transportDate: number;
    transportReason: string;
    transportReasonId: number | undefined;
    pickUpStartDateTime?: number;
    pickUpEndDateTime?: number;
    dropOffStartDateTime?: number;
    dropOffEndDateTime?: number;
    pickUpWindowSpecified: boolean;
    dropOffWindowSpecified: boolean;
    pickUpWindowInputMode?: WindowInputMode | null;
    dropOffWindowInputMode?: WindowInputMode | null;
    pickUpTimeSlotPresetId?: number | null;
    dropOffTimeSlotPresetId?: number | null;
    vehicle: Vehicle;
    drivability: AssignmentDrivability;
    transportedByRoad: boolean;
    priority: AssignmentPriority;
    emptyRideStatuses: TrajectoryEmptyRideStatus[];
    source: AssignmentSource;
    status: AssignmentStatus;
    statusHistory: StatusHistory[];
    createdOn: number;
    createdByName?: string;
    internalRemarks?: string;
    externalRemarks?: string;
    intermediaryName?: string;
    totalRevenue: number;
    revenueOverride: number | null;
    pickupContactPersonName?: string;
    pickupContactPersonEmail?: string;
    pickupContactPersonPhone?: string;
    dropoffContactPersonName?: string;
    dropoffContactPersonEmail?: string;
    dropoffContactPersonPhone?: string;
    invoiced: boolean;
    /** Werkitem 7429: berekend door de backend; false = op slot door de organisatie-instelling. */
    clientMayEdit: boolean;
}

export const DefaultAssignment = (): Assignment => {
    return {
        id: 0,
        clientName: '',
        pickUpRelationName: '',
        pickUpRelationId: 0,
        pickUpAddress: DefaultAddress(),
        dropOffRelationName: '',
        dropOffRelationId: 0,
        dropOffAddress: DefaultAddress(),
        transportDate: new Date().getTime(),
        transportReason: '',
        transportReasonId: undefined,
        createdOn: new Date().getTime(),
        vehicle: DefaultVehicle(),
        pickUpWindowSpecified: false,
        dropOffWindowSpecified: false,
        drivability: AssignmentDrivability.Drivable,
        transportedByRoad: false,
        priority: AssignmentPriority.Normal,
        emptyRideStatuses: [],
        status: AssignmentStatus.ToPlan,
        statusHistory: [],
        source: AssignmentSource.CreatedInTms,
        intermediaryName: '',
        totalRevenue: 0,
        revenueOverride: null,
        invoiced: false,
        clientMayEdit: true,
    }
}

